import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";


export class PacketOutJoinGame extends PacketOut {
    public static readonly SPECTATOR_KEY = "spectator";

    private readonly spectator: boolean;

    constructor(spectator: boolean) {
        super(OutboundPacketType.JOIN_GAME);
        this.spectator = spectator;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            [PacketOutJoinGame.SPECTATOR_KEY]: this.spectator,
        };
    }
}
